export default "__VITE_ASSET__BYht9Vs5__"